import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import * as actions from '../actions/micustomeractions'
import MedicalInsuranceStepper from '../components/Stepper'
export default function Customerquote() {
    const dispatch = useDispatch();
    const location = useLocation();    
    console.log('location object', location)

    useEffect(() => {        
        const queryParams = new URLSearchParams(location.search);
        const source = queryParams.get("utm_source");

        if (source) {           
            dispatch(actions.setUtmSource(source.toUpperCase()));
        }
    }, [location.search]);

    return (<>
        <MedicalInsuranceStepper />
    </>)
}